import { render, staticRenderFns } from "./DefaultLayouts.vue?vue&type=template&id=37c9a593&"
import script from "./DefaultLayouts.vue?vue&type=script&lang=ts&"
export * from "./DefaultLayouts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports